import React, { useEffect, useState } from 'react';
import './Confetti.css';

/**
 * Confetti Component
 * Reusable confetti animation component for celebrations
 * 
 * @param {number} duration - Animation duration in milliseconds (default: 3000)
 * @param {number} particleCount - Number of confetti particles (default: 50)
 */
const Confetti = ({ duration = 3000, particleCount = 50 }) => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsActive(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  if (!isActive) {
    return null;
  }

  const particles = Array.from({ length: particleCount }, (_, i) => i);

  return (
    <div className="confetti-container">
      {particles.map((index) => {
        const left = Math.random() * 100;
        const animationDelay = Math.random() * 0.5;
        const animationDuration = 2 + Math.random() * 2;
        const size = 8 + Math.random() * 8;
        const colorIndex = Math.floor(Math.random() * 5);
        const colors = [
          'var(--primary-color)',
          'var(--primary-light)',
          '#10b981',
          '#f59e0b',
          '#8b5cf6'
        ];

        return (
          <div
            key={index}
            className="confetti-particle"
            style={{
              left: `${left}%`,
              animationDelay: `${animationDelay}s`,
              animationDuration: `${animationDuration}s`,
              width: `${size}px`,
              height: `${size}px`,
              backgroundColor: colors[colorIndex]
            }}
          />
        );
      })}
    </div>
  );
};

export default Confetti;







